<template>
  <!-- 登录页面 -->
  <div class=" x-flex x-row-right x-col-start"
    :class="$store.state.djsAdmin.saas_type_id == 'sipCy' ? 'loginCy' : 'login'">
    <!-- 登录窗口 -->
    <div class="left-login x-flex x-h100p x-row-center" style="flex-direction: column;">
      <div class="login-box bgc-f x-text-c x-flex x-row-between" style="flex-direction: column;position: relative;">
        <div style="position: absolute;top: 0;right: 0;" @click="login_type = login_type == 'scan' ? 'phone' : 'scan'"
          class="x-cur-poi">
          <img v-if="login_type != 'scan'" src="@/assets/img/login/login-icon-code.png" alt="">
          <img v-else src="@/assets/img/login/login-icon-pc.png" alt="">
        </div>
        <div class="tip-btn x-cur-poi" @click="login_type = login_type == 'scan' ? 'phone' : 'scan'">
          {{ fLng(login_type != 'scan' ? '扫码登录' : '账号登录', 'login') }}
        </div>
        <div v-show="login_type != 'scan'" class="x-w100p x-h100p x-flex x-row-between" style="flex-direction: column;">

          <div class="x-w100p">
            <div class="x-font-26 x-p-t-20 x-p-b-30 f600">{{ fLng('欢迎登录', 'login') }}</div>
            <div class="x-flex x-w100p x-row-center c-80 x-font-16 x-p-b-20 ">
              <div class='x-flex-1 x-p-t-8 x-p-b-8  x-bd-bottom x-cur-poi' @click='login_type = "phone"'
                :class='login_type == "phone" ? "isActive" : ""'>{{ fLng('手机号登录', 'login')
                }}</div>
              <div class='x-flex-1 x-p-t-8 x-p-b-8   x-cur-poi  x-bd-bottom ' @click='login_type = "account"'
                :class='login_type == "account" ? "isActive" : ""'>{{ fLng('员工号登录',
                  'login') }}</div>
            </div>
          </div>
          <!-- phone -->
          <div class="x-w100p x-flex-1" v-if="login_type == 'phone'">
            <div class="x-m-b-20 x-m-t-10">
              <el-input prefix-icon="el-icon-mobile-phone" v-model="login_phone" autocomplete="off"
                :placeholder="fLng('请输入商户绑定手机号', 'login')"></el-input>
            </div>
            <div class="x-m-b-20 x-m-t-10" v-if="phone_login_type == 'password'">
              <el-input prefix-icon="el-icon-lock" v-model="phone_psw" type="password" name="password"
                autocomplete="new-password" :placeholder="fLng('请输入密码', 'login')" show-password></el-input>
            </div>
            <div class="x-m-b-20 x-m-t-10" style="position: relative;" v-if="phone_login_type == 'sms'">
              <el-input prefix-icon="el-icon-lock" name="code" v-model="phone_code" autocomplete="new-password"
                :placeholder="fLng('请输入验证码', 'login')">
              </el-input>
              <div style="position: absolute;right: 10px;top: 50%;transform: translateY(-50%);">
                <el-button type="text" @click="fGetCode" class="c-007AFB">{{ fLng(code_text, 'login') }}</el-button>
              </div>
            </div>

          </div>
          <!-- account -->
          <div class="x-w100p x-flex-1" v-if="login_type == 'account'">
            <div class="x-m-b-20 x-m-t-10">
              <el-input prefix-icon="el-icon-office-building" v-model="mch_id" autocomplete="off"
                :placeholder="fLng('请输入商户号', 'login')"></el-input>
            </div>
            <div class="x-m-b-20 x-m-t-10">
              <el-input prefix-icon="el-icon-user" v-model="user_id" autocomplete="off"
                :placeholder="fLng('请输入员工号', 'login')"></el-input>
            </div>
            <div class="x-m-b-20 x-m-t-10">
              <el-input prefix-icon="el-icon-lock" v-model="user_psw" :placeholder="fLng('请输入密码', 'login')"
                show-password></el-input>
            </div>

          </div>
          <!-- 登录 -->
          <div class="x-w100p ">
            <div class="x-flex x-row-end x-p-b-10">
              <el-checkbox v-model="isAgree"></el-checkbox>
              <div class="x-p-l-6 x-p-r-2 ">{{ fLng('我已阅读并同意', 'login') }}</div>
              <div class="x-cur-poi sm-color-blue">{{ fLng('《服务协议》', 'login') }}</div>
            </div>
            <el-button style="width: 100%;font-size: 16px;" type="primary" @click='fUserLogin'>{{ fLng('登录',
              'login') }}</el-button>
            <div class="x-flex x-row-between x-p-t-10">
              <div class="x-flex x-row-end x-p-b-10">
                <el-checkbox v-model="isRemember"></el-checkbox>
                <div class="x-p-l-6 x-p-r-2 ">{{ fLng('记住密码', 'login') }}</div>
              </div>
              <div class="x-flex x-row-end x-p-b-10 x-cur-poi x-hover" v-show="login_type == 'phone'"
                @click="phone_login_type = phone_login_type == 'password' ? 'sms' : 'password'">

                <img src="@/assets/img/login/change-icon.png" alt="" style="width: 12px;height: 12px;">
                <span class="x-p-l-6">{{ phone_login_type == 'password' ? fLng('验证码登录', 'login') : fLng('密码登录', 'login')
                }}</span>
              </div>
            </div>
            <div class=" x-p-t-20  x-flex x-row-center ">
              <!-- <div class="x-cur-poi x-hover" style="margin-right: 10px;">{{ fLng('忘记密码', 'login') }}</div>
              <div style="margin-bottom: 2px;">|</div> -->
              <div class="x-cur-poi x-hover" style="margin-left: 10px;" @click="fShowRegisterQrCode">{{ fLng('免费注册',
                'login') }}</div>
            </div>
          </div>
        </div>
        <div v-show="login_type == 'scan'" class="x-w100p x-h100p x-flex x-row-between" style="flex-direction: column;">
          <div class="x-font-26 x-p-t-20 x-p-b-30 f600">{{ fLng('欢迎登录', 'login') }}</div>
          <div class="x-font-16 x-p-t-20 x-p-b-30 f600">
            {{ fLng('敬请期待', 'login') }}
          </div>
          <div class="x-font-16 x-p-t-20 x-p-b-30 f600">
            打开商户端，扫一扫登录
          </div>
        </div>
      </div>

    </div>



    <div class="x-p-l-10 x-cur-poi" style="position: absolute;right: 20px;top: 20px;height: 40px;">
      <el-dropdown>
        <span class="el-dropdown-link " style="color: #fff;">
          {{ $store.state.djsAdmin.lng_name }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(item, index) in langList" :key="index">
            <div @click="fChgLng(item)">{{ item.label }}</div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- 修改密码的弹窗 -->
    <el-dialog :visible.sync="changePassword" width="400px" :close-on-click-modal="false" :show-close="false"
      :close-on-press-escape="false" class="pl-edit-dialog">
      <div class="x-sm-pop-head">
        <div class="x-flex">
          <div class='x-flex x-h50 x-m-r-20'>{{ fLng('修改密码', 'vip') }}
          </div>
        </div>
        <div class="x-flex ">
          <i class="el-icon-close x-font-16 x-p-2 " style="cursor: pointer; color:#808080 ;"
            @click="changePassword = false"></i>
        </div>
      </div>
      <div class="x-w100p x-p-30" style="padding-bottom:0 ;">
        <!-- 旧密码 -->
        <div class="x-w100p x-h42 x-p-b-10 x-d-flex x-lh-32">
          <div class="x-w70 x-d-flex x-row-right x-p-r-10">
            <div>旧密码</div>
          </div>
          <div class="x-flex-1 x-w100p">
            <el-input size="small" v-model="oldPassword" placeholder="" show-password></el-input>
          </div>
        </div>
        <!-- 新密码 -->
        <div class="x-w100p x-h42 x-p-b-10 x-d-flex x-lh-32">
          <div class="x-w70 x-d-flex x-row-right x-p-r-10">
            <div>新密码</div>
          </div>
          <div class="x-flex-1 x-w100p">
            <el-input size="small" v-model="newPassword" placeholder="" show-password></el-input>
          </div>
        </div>
        <!-- 确认密码 -->
        <div class="x-w100p x-h42  x-d-flex x-lh-32">
          <div class="x-w70 x-d-flex x-row-right x-p-r-10">
            <div>确认密码</div>
          </div>
          <div class="x-flex-1 x-w100p">
            <el-input size="small" v-model="confirmPassword" placeholder="" show-password></el-input>
          </div>
        </div>

      </div>
      <!-- 确定&取消 -->
      <div class="x-sm-pop-foot">
        <xButton width="70px" class="x-p-l-10" border="1px solid #DCDFE6" bgc="#fff" color="#242424"
          @click.native="changePassword = false">取消</xButton>
        <xButton width="70px" class="x-p-l-10" @click.native="determineAdd">确定</xButton>
      </div>
    </el-dialog>
    <!-- 续费 -->
    <renew ref="renew" :isShow.sync="isShowRenew" :info="mallInfo" @close="fCancalPopupShow" @sucess="fSucess"
      @updata="fUpdata">
    </renew>

    <!-- 注册二维码弹窗 -->

    <el-dialog :visible="showRegQrCode" width="400px" :show-close="false" :close-on-click-modal="false"
      :appendToBody='true'>
      <div class="x-flex x-row-between x-bd-bottom-E x-p-l-20 x-p-r-14">
        <div class="x-flex">
          <div class='x-flex x-h50 x-m-r-20'>{{ fLng('免费注册', 'login') }}</div>
        </div>
        <div class="x-flex ">
          <i class="el-icon-close x-font-16 x-p-2 " style="cursor: pointer; color:#808080 ;"
            @click="showRegQrCode = false"></i>
        </div>
      </div>
      <div class="x-flex x-row-center x-col-center" style="padding: 20px 0;">
        <div class="x-text-c">
          <div class="x-font-16 x-p-b-20">扫描下方二维码注册</div>
          <div class="x-p-b-20">
            <div id="regQrCode" style="width: 200px; height: 200px; margin: 0 auto;"></div>
          </div>
          <div class="x-font-14 c-80">打开微信扫一扫</div>
        </div>
      </div>
      <div class="x-sm-pop-foot">
        <x-button @click.native="showRegQrCode = false">关闭</x-button>

      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  Message,
  Loading
} from 'element-ui'; //项目已经全局引入element的话可以不单独引入
let loading
import renew from './renew.vue'
import QRCode from "qrcodejs2";
export default {
  components: {
    renew
  },
  data() {
    return {
      mallInfo: {},
      isShowRenew: false,
      langList: [{
        label: '中文',
        value: 'zh-CN'
      }, {
        label: 'English',
        value: 'en-US'
      },],

      errMsg: {},
      login_phone: '',
      phone_psw: '',
      phone_code: '',
      user_id: this.$store.state.djsAdmin.userId,
      user_psw: "",
      tipsMsg: '',
      isSuccess: true,

      // verType: this.$store.state.softVer == '餐饮' ? 'djs3.0' : 'smSell5.0',
      //选择登录方法
      active: 'phone',
      //用户登录信息
      mch_id: '',
      mall_id: '',
      user_id: '',
      user_psw: '',
      yzm: '',
      //错误提示
      errMsg: {
        mch_id: '',
        mall_id: '',
        userId: '',
        userPsw: '',
        yzm: '',
      },
      mallList: [],
      // 用户协议
      isAgree: false,
      canLogin: 'N',
      can_get_code: true,
      code_text: '获取验证码',
      code_count: 60,
      code_timer: null,
      req_id: '',
      isRemember: false,
      login_type: 'phone',
      phone_login_type: 'password',
      // 修改密码
      changePassword: false,
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      from: '',
      bgType: '',
      // 注册二维码
      showRegQrCode: false,
      qrContentCy: '',
      qrContentLs: '',
      smCloudOrgApplet: {
        org_id: '320250710'
      },
    };
  },
  computed: {},
  watch: {},
  async created() {
    //获取地址栏参数
    //http://192.168.1.26:8081/#/login?mch=8202508130000115&u=1001&mi=10011001&mn=&f=android&st=sipCy&t=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI4MjAyNTA4MTMwMDAwMTE1MTAwMSIsImlhdCI6MTc1NTI0MTM4MiwiZXhwIjoxNzU3ODMzMzgyLCJpc3MiOiIxMDAxMTAwMSJ9.spgwEOyhe_znjp2RNufFAQJDaoTWcbhObaEL7ScvMMNQjIg-OCB61qv4llF0b0FWv7UtRJSbHngrtCYyZrUUQA

    //
    let url = window.location.href;
    let urlParams = new URLSearchParams(url.split('?')[1]);
    console.log(urlParams)
    // this.bgType = urlParams.get('st'); //背景图
    // console.log(this.bgType )

    let f = urlParams.get('f'); //来源 android
    let mch = urlParams.get('mch'); //mch_id
    let u = urlParams.get('u'); //user_id
    let t = urlParams.get('t'); //token
    let mi = urlParams.get('mi'); //mall_id
    let mn = urlParams.get('mn'); //mall_name
    let st = urlParams.get('st'); //saas_type_id

    // console.log(from)
    if (!this.api.smCom.fSmIsEmpty(st)) {
      this.$store.commit('setState', {
        key: 'saas_type_id',
        value: st
      });
    }
    if (f == 'android') {
      // this.from = from
      // this.mch_id = mch_id
      // this.user_id = user_id
      // this.token = token
      // this.mall_id = mall_id
      // this.mall_name = mall_name
      this.startLoading()
      const resSvr = await this.GET_SAAS_MCH_INFO({
        mch_id: mch
      });
      this.hideLoading()
      if (resSvr.result !== 'sucess') {
        return this.$message.error(resSvr.msg);
      }
      this.$store.commit('mall_id', mi);
      this.$store.commit('mall_name', mn);
      this.$store.commit('user_id', u);
      this.$store.commit('mch_id', mch);
      this.$store.commit('djsAdminToken', t);

      this.$store.commit('load_url', resSvr.data.api_url);
      if (this.$store.state.djsAdmin.saas_type_id == 'sipLs') {
        this.fUpdatePageTitle(); // 更新页面标题
        this.$router.push({
          path: '/lsNav'
        })
      } else {
        this.fUpdatePageTitle(); // 更新页面标题
        this.$router.push({
          path: '/cpNav'
        })
      }
      return
    }




    this.isRemember = this.$store.state.djsAdmin.isRemember
    this.isAgree = this.$store.state.djsAdmin.isAgree
    if (this.isRemember) {
      this.login_type = this.$store.state.djsAdmin.login_type
      if (this.login_type == 'phone') {
        this.phone_psw = this.$store.state.djsAdmin.login_psw
      } else {
        this.user_psw = this.$store.state.djsAdmin.login_psw
      }
    }
    this.login_phone = this.$store.state.djsAdmin.login_phone
    this.mch_id = this.$store.state.djsAdmin.mch_id
    this.mall_id = this.$store.state.djsAdmin.mall_id || '10011001'
    this.user_id = this.$store.state.djsAdmin.user_id
  },
  methods: {
    startLoading() { //使用Element loading-start 方法
      loading = Loading.service({
        lock: true,
        text: '加载中……',
        background: 'rgba(0, 0, 0, 0)'
      })
    },
    hideLoading() { //使用Element loading-close 方法
      loading.close()
    },
    fChgLng(item) {
      this.$store.commit('lng', item.value);
      this.$store.commit('lng_name', item.label);

      window.location.reload();
      // this.$forceUpdate()
    },
    fChgMall(e) {
      let obj = {};
      obj = this.mallList.find((item) => {
        return item.mall_id === e; //筛选出匹配数据
      });
      this.$store.commit('mall_id', obj.mall_id)
      this.$store.commit('mall_name', obj.mall_name)
      if (this.login_type == 'phone') {
        this.$nextTick(() => {
          this.$refs.psw.focus()
        })
      }

    },
    // fChgLoginType() {
    //   this.login_type = this.login_type == 'phone' ? 'account' : 'phone'
    //   this.phone_login_type = 'password'
    //   this.phone_psw = ''
    //   this.phone_code = ''
    //   this.user_id = ''
    //   this.user_psw = ''
    //   this.mch_id = ''
    // },
    //改变焦点
    fChgFous(ref) {
      if (ref == 'mch_id') {
        this.$nextTick(() => {
          this.$refs.userId.focus()
        })
      }
      if (ref == 'userId') {
        this.$nextTick(() => {
          this.$refs.shMall.focus()
        })
      }
      if (ref == 'login') {
        this.fUserLogin()
      }
    },
    async fGetCode() {

      let mch_id = ''; let user_id = '';
      if (!this.can_get_code) return;
      // 这里可以加手机号校验
      console.log(this.login_phone)
      console.log(this.api.smCom.fSmIsEmpty(this.login_phone))
      if (this.api.smCom.fSmIsEmpty(this.login_phone)) {
        return this.$message.error('请输入手机号')
      }

      const resMch = await this.api.smCommon.GET_SAAS_MCH_USER_BAND_INFO({
        oper: 'BAND_MCH_USER_ID',
        acct_id: this.login_phone,
        band_type: 'PHONE',
      });
      if (resMch.result != 'sucess') {
        return this.$message.error(resMch.msg)
      }
      this.$store.commit('load_url', resMch.data.api_url);

      mch_id = resMch.data.mch_id
      this.$store.commit('mch_id', mch_id);

      user_id = resMch.data.user_id

      this.can_get_code = false;
      this.code_text = `${this.code_count}s`;
      this.code_timer = setInterval(() => {
        this.code_count--;
        if (this.code_count <= 0) {
          clearInterval(this.code_timer);
          this.code_text = '获取验证码';
          this.can_get_code = true;
          this.code_count = 60;
        } else {
          this.code_text = `${this.code_count}s`;
        }
      }, 1000);
      // 这里可以调用发送验证码的接口
      let res = await this.SEND_SMS_CODE(mch_id)
      if (res.result != 'sucess') {
        clearInterval(this.code_timer);
        this.code_text = '获取验证码';
        this.can_get_code = true;
        this.code_count = 60;
        return this.$message.error(res.msg)

      } else {
        this.req_id = res.req_id
        this.$message('验证码发送成功')
      }
    },
    async fUserLogin() {
      let mch_id = ''
      let user_id = ''
      let user_psw = ''

      // 1. 校验输入
      if (this.login_type === 'account') {
        if (this.api.smCom.fSmIsEmpty(this.mch_id)) {
          return this.$message(this.fLng('请输入商户号', 'login'));
        }
        if (this.api.smCom.fSmIsEmpty(this.user_id)) {
          return this.$message(this.fLng('请输入用户名', 'login'));
        }
        if (this.api.smCom.fSmIsEmpty(this.user_psw)) {
          return this.$message(this.fLng('请输入密码', 'login'));
        }
        if (!this.isAgree) {
          return this.$message(this.fLng('请先阅读并同意《服务协议》', 'login'));
        }
        mch_id = this.mch_id
        user_id = this.user_id
        user_psw = this.user_psw


      } else if (this.login_type === 'phone') {
        if (this.api.smCom.fSmIsEmpty(this.login_phone)) {
          return this.$message(this.fLng('请输入用户名', 'login'));
        }
        if (this.api.smCom.fSmIsEmpty(this.phone_psw) && this.phone_login_type == 'password') {
          return this.$message(this.fLng('请输入密码', 'login'));
        }
        if (this.api.smCom.fSmIsEmpty(this.phone_code) && this.phone_login_type == 'sms') {
          return this.$message(this.fLng('请输入验证码', 'login'));
        }
        if (!this.isAgree) {
          return this.$message(this.fLng('请先阅读并同意《服务协议》', 'login'));
        }
        // 查询手机号绑定信息
        const res = await this.api.smCommon.GET_SAAS_MCH_USER_BAND_INFO({
          oper: 'BAND_MCH_USER_ID',
          acct_id: this.login_phone,
          band_type: 'PHONE',
        });
        if (res.result !== 'sucess') {
          return this.$message.error(res.msg);
        }
        if (!res.data || res.data.length < 1) {
          return this.$message(this.fLng('该手机号下无门店信息', 'login'));
        }
        // 这里可以根据实际业务需要赋值 user_id/mch_id

        mch_id = res.data.mch_id
        user_id = res.data.user_id
        user_psw = this.phone_psw
        if (this.phone_login_type == 'sms') {
          user_psw = this.phone_code
        }
        if (res.data.state_id != 'sipYjh') {
          const res = await this.api.smCommon.CRT_SAAS_DB({
            mch_id: mch_id,
          });
          if (res.result !== 'sucess') {
            return this.$message.error(res.msg);
          }
          this.$store.commit('load_url', res.data.api_url);
          // 重新登录
          await this.fUserLogin();
          return;
        }
        this.$store.commit('load_url', res.data.api_url);
      }



      // 2. 切换账号时，先查商户信息
      if (
        this.login_type === 'account' &&
        (this.$store.state.djsAdmin.mch_id !== this.mch_id ||
          this.$store.state.djsAdmin.user_id !== this.user_id)
      ) {
        const resSvr = await this.GET_SAAS_MCH_INFO({
          mch_id: this.mch_id
        });
        if (resSvr.result !== 'sucess') {
          return this.$message.error(resSvr.msg);
        }
        if (resSvr.data.state_id != 'sipYjh') {
          const res = await this.api.smCommon.CRT_SAAS_DB({
            mch_id: this.mch_id,
          });
          if (res.result !== 'sucess') {
            return this.$message.error(res.msg);
          }
          this.$store.commit('load_url', resSvr.data.api_url);
          // 重新登录
          await this.fUserLogin();
          return;
        }
        this.$store.commit('load_url', resSvr.data.api_url);
      }

      this.$store.commit('setState', {
        key: 'isAgree',
        value: this.isAgree
      });
      this.$store.commit('setState', {
        key: 'isRemember',
        value: this.isRemember
      });

      // 3. 登录请求
      this.$store.commit('mall_id', '10011001');
      let res
      if (this.login_type == 'phone' && this.phone_login_type == 'sms') {
        if (this.api.smCom.fSmIsEmpty(this.req_id)) {

          return this.$message(this.fLng('请重新获取验证码', 'login'));
        }
        res = await this.USER_LOGIN({
          oper: 'USER_SMS',
          mch_id: mch_id,
          login_phone: this.login_phone,
          user_id: user_id,
          req_id: this.req_id,
          user_psw: user_psw
        });
      } else {
        res = await this.USER_LOGIN({
          oper: 'USER_PSW',
          mch_id: mch_id,
          user_id: user_id,
          user_psw: user_psw
        });
      }
      this.$store.commit('setState', {
        key: 'org_id',
        value: res.org_id
      });

      if (res.result !== 'sucess') {
        if (res.sub_msg == 'sipYdq') {
          this.$store.commit('setState', {
            key: 'mch_id',
            value: res.mch_id
          });
          // 单店续费
          this.mallInfo = {
            mall_name: res.mall_name,
            mall_id: res.mall_id,
            exp_time: res.exp_time,
            saas_type_id: res.saas_type_id,
          }

          return this.isShowRenew = true
        }
        return this.$message.error(res.msg);
      }
      this.$store.commit('djsAdminToken', res.token);
      this.$store.commit('mch_id', mch_id);
      this.$store.commit('setState', {
        key: 'saas_type_id',
        value: res.saas_type_id
      });
      this.$store.commit('setState', {
        key: 'login_phone',
        value: this.login_phone
      });

      //判断是否记住密码
      // if (this.isRemember) {
      if (this.login_type == 'phone') {
        this.$store.commit('setState', {
          key: 'login_psw',
          value: this.phone_psw
        });
        if (this.login_phone.substr(this.login_phone.length - 4, 4) == this.phone_psw) {
          this.changePassword = true
          this.oldPassword = this.phone_psw
          return
        }
      } else {
        this.$store.commit('setState', {
          key: 'login_psw',
          value: this.user_psw
        });
      }
      // }

      this.$store.commit('setState', {
        key: 'mall_num',
        value: res.mall_num
      });

      // 4. 登录成功，存储信息
      this.$store.commit('user_id', res.user_info.user_id);
      this.$store.commit('user_name', res.user_info.user_name);
      // this.$store.commit('supperAuth', res.user_info.supper_auth);
      this.$store.commit('setState', {
        key: 'login_type',
        value: this.login_type
      });
      if (this.from == 'android') {
        // this.$store.commit('setState', {
        //   key: 'org_id',
        //   value: res.org_id
        // });
        this.$store.commit('mall_id', this.mall_id);
        this.$store.commit('mall_name', this.mall_name);
        this.$store.commit('setState', {
          key: 'saas_type_id',
          value: res.saas_type_id
        });
        this.$store.commit('setState', {
          key: 'user_auth_info',
          value: res.user_auth_info
        });
        if (res.mall_num > 1) {
          this.$store.commit('setState', {
            key: 'user_mall_list',
            value: res.user_mall_list
          });
        } else {
          this.$store.commit('setState', {
            key: 'color_yn_id',
            value: res.user_mall_info[0].color_yn_id
          });
          this.$store.commit('setState', {
            key: 'size_yn_id',
            value: res.user_mall_info[0].size_yn_id
          });
          this.$store.commit('setState', {
            key: 'user_mall_list',
            value: res.mall_id
          });
        }

        if (this.$store.state.djsAdmin.saas_type_id == 'sipLs') {
          this.fUpdatePageTitle(); // 更新页面标题
          this.$router.push('lsNav');
        } else {
          this.fUpdatePageTitle(); // 更新页面标题
          this.$router.push('cpNav');
        }



        return
      }
      if (res.mall_num > 1) {
        //如果储存的信息和上一次的一致 则直接登录
        // if (mch_id == this.$store.state.djsAdmin.mch_id
        //   && res.user_info.user_id == this.$store.state.djsAdmin.user_id) {
        //   return this.$router.push('cpNav');
        // }
        this.$store.commit('setState', {
          key: 'user_mall_list',
          value: res.user_mall_list
        });
        this.$router.push('mall_list');
      } else {
        this.$store.commit('setState', {
          key: 'color_yn_id',
          value: res.user_mall_info[0].color_yn_id
        });
        this.$store.commit('setState', {
          key: 'size_yn_id',
          value: res.user_mall_info[0].size_yn_id
        });

        // this.$store.commit('mall_id', res.user_mall_info[0].mall_id);
        this.$store.commit('setState', {
          key: 'mall_id',
          value: res.user_mall_info[0].mall_id
        });

        this.$store.commit('mall_name', res.user_mall_info[0].mall_name);
        this.$store.commit('setState', {
          key: 'saas_type_id',
          value: res.saas_type_id
        });
        this.$store.commit('setState', {
          key: 'user_auth_info',
          value: res.user_auth_info
        });
        this.$store.commit('setState', {
          key: 'user_mall_list',
          value: res.mall_id
        });

        console.log(this.api.timeHelper.fTime2NowDay(res.exp_time), 'this.api.timeHelper.fTime2NowDay(res.exp_time)')
        if (this.api.timeHelper.fTime2NowDay(res.exp_time) < 7) {
          // 获取带有日期信息的已提示记录，从store中读取
          let alertedMalls = this.$store.state.djsAdmin.alertedExpiringMalls || {}
          const today = new Date().toLocaleDateString('zh-CN') // 获取今天的日期字符串
          const mallAlertKey = `${res.mall_id}`

          // 检查今天是否已经提示过
          const lastAlertDate = alertedMalls[mallAlertKey]
          if (!lastAlertDate || lastAlertDate !== today) {
            this.mallInfo = {
              mall_name: res.user_mall_info[0].mall_name,
              mall_id: res.user_mall_info[0].mall_id,
              exp_time: res.exp_time,
              saas_type_id: res.saas_type_id,
            }
            this.$message.error('店铺过期时间小于7天')
            // 更新提示记录，存储今天的日期
            alertedMalls[mallAlertKey] = today
            // 使用store的setState方式存储
            this.$store.commit('setState', {
              key: 'alertedExpiringMalls',
              value: alertedMalls
            })

            // 延迟打开renew组件，确保错误提示正常显示
            setTimeout(() => {
              this.isShowRenew = true
            }, 500)
            return
          }
        }

        if (this.$store.state.djsAdmin.saas_type_id == 'sipLs') {
          this.fUpdatePageTitle(); // 更新页面标题
          this.$router.push('lsNav');
        } else {
          this.fUpdatePageTitle(); // 更新页面标题
          this.$router.push('cpNav');
        }
      }



    },
    fUpdata(data) {
      console.log(data, 'data')
      Object.assign(this.mallInfo, data)
    },
    fSucess() {
      this.fUserLogin()
    },
    fCancalPopupShow() {
      this.isShowRenew = false
    },
    /**
     * 根据登录版本更新页面标题
     */
    fUpdatePageTitle() {
      const saasTypeId = this.$store.state.djsAdmin.saas_type_id;
      let title = '餐饮后台管理系统'; // 默认标题

      // 根据不同的 saas_type_id 设置不同的标题
      if (saasTypeId === 'sipCy') {
        title = '餐饮后台管理系统';
      } else if (saasTypeId === 'sipLs') {
        title = '零售后台管理系统';
      } else if (saasTypeId === 'sipHm') {
        title = '行业后台管理系统';
      } else {
        title = '后台管理系统';
      }

      // 更新页面标题
      document.title = title;
    },
    // 成功回调
    // async onSuccess() {
    //   this.tipsMsg = '恭喜您，验证成功啦！';
    //   this.isSuccess = true;
    //   let res = await this.api.smCommon.MAIN_ORG_USER_LOGIN({
    //     oper: 'USER_LOGIN',
    //     user_id: this.user_id,
    //     user_psw: this.user_psw,
    //   })
    //   if (res.result != 'sucess') {
    //     return this.$message.error(res.msg)
    //   }
    //   this.$store.commit('djsAdminToken', res.token); // 存本地
    //   // 记录关键信息到本地
    //   this.$store.commit('mch_id', res.org_info.boss_phone);
    //   this.$store.commit('orgName', res.org_info.org_name);
    //   this.$store.commit('orgId', res.org_info.org_id);
    //   this.$store.commit('userId', res.user_info.user_id);
    //   this.$store.commit('user_id', res.user_info.user_name);
    //   this.$store.commit('supperAuth', res.user_info.supper_auth);
    //   // 条件判断通过==【跳转到首页】
    //   if (this.$store.state.djsAdmin.saas_type_id == 'sipLs') {
    //     this.$router.push('lsNav');
    //   } else {
    //     this.$router.push('cpNav');
    //   }
    // },
    // ---------------------- 请求函数 开始 ------------------------
    // 修改密码=确定
    async determineAdd() {
      if (this.api.smCom.fSmIsEmpty(this.oldPassword)) {
        return this.$message(this.fLng('请输入旧密码', 'login'));
      }
      if (this.api.smCom.fSmIsEmpty(this.newPassword)) {
        return this.$message(this.fLng('请输入新密码', 'login'));
      }
      if (this.api.smCom.fSmIsEmpty(this.confirmPassword)) {
        return this.$message(this.fLng('请输入确认密码', 'login'));
      }
      if (this.newPassword == this.confirmPassword) {
        let res = await this.fUserChgPsw()
        if (res.result != "sucess") {
          return this.$message.error(res.msg)
        }
        this.$message(res.msg);
        this.changePassword = false
        this.phone_psw = this.newPassword
      } else {
        this.$message.error('确认密码与修改的密码不一至！');
      }
    },
    // 修改密码  USER_CHG_PSW
    async fUserChgPsw(oper) {
      let js = {};
      js['OPER'] = 'CHG'

      js['USER_ID'] = this.$store.state.djsAdmin.user_id
      js['OLD_PSW'] = this.oldPassword
      js['NEW_PSW'] = this.newPassword
      js['CHG_USER_ID'] = this.$store.state.djsAdmin.user_id
      let res = await this.api.djsApi.fDjsAdminApi({
        methodName: 'USER_CHG_PSW',
        js,
        userId: this.$store.state.djsAdmin.user_id
      })
      return res;
    },
    // 登录 ORG_USER_LOGIN
    async USER_LOGIN(obj) {
      let js = {};
      js['OPER'] = obj.oper
      js['MCH_ID'] = obj.mch_id
      js['DEVICE_ID'] = '01'
      js['USER_ID'] = obj.user_id
      js['USER_PHONE'] = obj.login_phone
      js['USER_PSW'] = obj.user_psw
      js['SOFT_VER'] = 'djs5.0'
      js['AUTH_TYPE'] = '1'
      js['DEVICE_INFO'] = ''
      js['APP_NAME'] = ''
      js['REQ_ID'] = obj.req_id
      js['APP_VER_NO'] = this.$store.state.ver
      js['SAAS_VER_ID'] = 'sipDjs'


      let res = await this.api.djsApi.fDjsAdminApi({
        methodName: 'USER_LOGIN',
        js,
        userId: obj.user_id,
        mchId: obj.mch_id,
      })
      return res;
    },


    async GET_SAAS_MCH_INFO(obj) {
      let js = {};
      js['OPER'] = 'SRV_IP'
      js['MCH_ID'] = obj.mch_id
      let res = await this.api.djsApi.fSmCloudQueryApi({
        methodName: 'GET_SAAS_MCH_INFO',
        js,
        mchId: '320250710',
        userId: '320250710',
        signType: 'MD5',
        sOrgAk: 'tucy6kfCCANmOKVvi2K3KsovLeN3klACkgUY4lSb0bHSYxgUoQhZ2wPhysjKfKYf',
        sOrgSk: "Hewuyrmli9JGRu9RLxOUMEcnKXK4xEyV4A5EYRSimxmw8Y06qYSvvKcNgzaKlJJk"
      })
      return res;
    },




    async SEND_SMS_CODE(mch_id) {
      let js = {};
      js["OPER"] = 'USER_LOGIN'
      js["PHONE"] = this.login_phone
      js["MALL_ID"] = mch_id
      js["SMS_ID"] = '1001'// 短信id：1001 通知短信、 1002 营销短信
      console.log(js)
      let res = await this.api.djsApi.fDjsAdminApi({
        methodName: 'SEND_SMS_CODE',
        js,

      });
      return res;
    },
    // 更新二维码内容
    fUpdateQrCodeContent() {
      // 在二维码内容中添加版本参数
      this.qrContentCy = `https://soft.shopzgl.com/mDjsAdmin/index.html#/pagesReg/selfReg/selfReg?org_id=${this.smCloudOrgApplet.org_id}&saas_type_id=sipCy&saas_ver_id=sipDjsxcy`
      this.qrContentLs = `https://soft.shopzgl.com/mDjsAdmin/index.html#/pagesReg/selfReg/selfReg?org_id=${this.smCloudOrgApplet.org_id}&saas_type_id=sipLs&saas_ver_id=sipDjsxls`
    },
    // 生成二维码
    fGenerateQrCode() {
      // 先清空之前的二维码
      const qrCodeElement = document.getElementById('regQrCode')
      if (qrCodeElement) {
        qrCodeElement.innerHTML = ''
      }
      // 选择要使用的二维码内容
      const qrContent = this.$store.state.djsAdmin.saas_type_id == 'sipCy' ? this.qrContentCy : this.qrContentLs

      // 生成新的二维码
      if (qrCodeElement && qrContent) {
        new QRCode(qrCodeElement, {
          text: qrContent,
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      }
    },
    // 显示注册二维码
    fShowRegisterQrCode() {
      this.fUpdateQrCodeContent()
      this.showRegQrCode = true
      // 延迟生成二维码，确保DOM已经渲染
      this.$nextTick(() => {
        this.fGenerateQrCode()
      })
    },
  },
  beforeCreate() { },
  beforeMount() { },
  mounted() {
    // 初始化二维码内容
    this.fUpdateQrCodeContent()
  }
}
</script>
<style lang="less" scoped="scoped">
.err {
  color: #F56C6C;
}



/deep/.el-button--primary:login_type {
  opacity: 0.8;
}


/deep/ .el-button--primary,
/deep/.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #007AFB;
  border-color: #007AFB;
  color: #FFFFFF;
}

.isActive {
  border-bottom: 2px solid #007AFB;
  color: #007AFB;
  font-weight: bold;
}

// 重置弹框样式
/deep/ .el-dialog__header {
  padding: 0 !important;
}

/deep/ .el-dialog__body {
  padding: 0 !important;
}

.loginCy {
  background: url('../assets/img/loginCy.png') no-repeat;
  // background: url('../assets/img/login.png') no-repeat;

}

.login {
  background: url('../assets/img/login.png') no-repeat;
}

.login,
.loginCy {
  width: 100vw;
  min-width: 1024px;
  height: 100vh;
  min-height: 768px;
  background-size: 100% 100%;
  // padding: 80px;
  // padding-right: 140px;
  position: relative;

  // padding: 60px 80px;
  .left-login {
    position: absolute;
    top: 50%;
    right: 14%;
    transform: translate(0, -50%);

    // padding-top:12vh;
    .login-box {

      border-radius: 10px;
      width: 400px;
      height: 550px;
      padding: 25px 30px;
    }

    /deep/.el-input__prefix {
      font-size: 18px;
    }

    /deep/.el-input__inner {
      height: 40px;
      font-size: 16px;
      padding-left: 35px;
    }
  }



  .tip-btn {
    position: absolute;
    top: 5px;
    right: 80px;
    color: #007AFB;
    font-size: 14px;
    padding: 4px 12px;
    background: #F3F8FF;
    border-radius: 3px;
    border: 1px solid #92BBFF;

    &:hover {
      opacity: 0.8;
    }

    &::before {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      right: -5px;
      /* 让内三角居中 */
      transform: translateY(-50%);
      /* 内层三角形（白色） */
      width: 0;
      height: 0;
      border-top: 8px solid transparent;
      border-bottom: 8px solid transparent;
      border-left: 6px solid #fff;
      z-index: 3;
    }

    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      right: -6px;
      transform: translateY(-50%);
      /* 外层三角形（边框色） */
      width: 0;
      height: 0;
      border-top: 8px solid transparent;
      border-bottom: 8px solid transparent;
      border-left: 6px solid #007AFB;
      z-index: 2;
    }
  }

  .loading-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/login.vue